import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BusyService } from 'app/core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'insol-outline-button',
  templateUrl: './outline-button.component.html',
})
export class OutlineButtonComponent {
  @Input() cssClass: string;
  @Input() color: string;
  @Input() disabled: boolean;
  @Output() clicked = new EventEmitter<MouseEvent>();

  isBusy$: Observable<boolean>;

  constructor(busyService: BusyService) {
    this.isBusy$ = busyService.busyState$.pipe(map((busyState) => busyState.isBusy));
  }
}
